/* Velunaris Signature: Sternenstaub, Reveal, Parallax, Tilt, Magnet, Streichpreis-Hinweis.
   Ohne JS bleibt alles sichtbar. Bei "Bewegung reduzieren" und im Theme-Editor ruhig. */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(w.Shopify && w.Shopify.designMode);
  if (design) root.classList.add('vs-design');

  /* ---------- Streichpreis-Hinweis nur, wenn wirklich ein Streichpreis aktiv ist ---------- */
  function initPangv() {
    var price = d.querySelector('.product__info-container .price');
    var tax = d.querySelector('.product__info-container .product__tax');
    if (!price || !tax) return;
    function upd() {
      var old = tax.parentNode.querySelector('.vs-pangv');
      var was = price.classList.contains('price--on-sale') && price.querySelector('.price__sale s .price-item--regular, .price__sale .price-item--regular');
      var txt = was && was.textContent.trim();
      if (!txt) { if (old) old.remove(); return; }
      var line = 'Vorheriger Preis ' + txt + ' = niedrigster Preis der letzten 30 Tage vor der Ermäßigung.';
      if (old) { old.textContent = line; return; }
      var el = d.createElement('span'); el.className = 'vs-pangv'; el.textContent = line;
      tax.parentNode.insertBefore(el, tax.nextSibling);
    }
    upd();
    try { new MutationObserver(upd).observe(price, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); } catch (e) {}
  }

  /* ---------- Reveal beim Scrollen ---------- */
  function initReveal() {
    var els = d.querySelectorAll('.vh-reveal');
    if (!els.length) return;
    if (reduce || design || !('IntersectionObserver' in w)) { root.classList.add('vh-noio'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 6000);
  }

  /* ---------- Parallax der Ritual-Bilder ---------- */
  function initParallax() {
    if (reduce || design) return;
    var els = [].slice.call(d.querySelectorAll('[data-vh-parallax]'));
    if (!els.length) return;
    var ticking = false;
    function run() {
      ticking = false;
      var vh = w.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var f = parseFloat(el.getAttribute('data-vh-parallax')) || .08;
        var off = (r.top + r.height / 2 - vh / 2) * -f;
        var img = el.querySelector('img');
        if (img) img.style.setProperty('--py', (off - r.height * .09).toFixed(1) + 'px');
      });
    }
    w.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* ---------- 3D-Neigung (Luna-Bild) + Magnet-Button ---------- */
  function initPointer() {
    if (reduce || design || !w.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    d.querySelectorAll('[data-vh-tilt]').forEach(function (fig) {
      var ph = fig.querySelector('.vh-photo'); if (!ph) return;
      fig.addEventListener('pointermove', function (e) {
        var r = fig.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        ph.style.setProperty('--ry', (x * 8).toFixed(2) + 'deg');
        ph.style.setProperty('--rx', (-y * 8).toFixed(2) + 'deg');
      });
      fig.addEventListener('pointerleave', function () { ph.style.setProperty('--ry', '0deg'); ph.style.setProperty('--rx', '0deg'); });
    });
    d.querySelectorAll('[data-vh-magnet]').forEach(function (btn) {
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        btn.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * .12).toFixed(1) + 'px,' + ((e.clientY - r.top - r.height / 2) * .2).toFixed(1) + 'px)';
      });
      btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
    });
  }

  /* ---------- Sternenstaub: goldene Funken steigen langsam auf, ab und zu eine Sternschnuppe ---------- */
  function initStardust() {
    if (reduce || design || !w.requestAnimationFrame) return;
    var cv = d.createElement('canvas');
    cv.className = 'vs-dust';
    cv.setAttribute('aria-hidden', 'true');
    d.body.appendChild(cv);
    var ctx = cv.getContext('2d');
    if (!ctx) return;
    var colors = ['234,210,146', '255,243,207', '216,184,108', '142,155,181'];
    var dots = [], W = 0, H = 0, dpr = 1, raf = 0, running = false, t0 = 0, shoot = null, nextShoot = 0;
    function count() { return W < 750 ? 16 : (W < 1200 ? 24 : 32); }
    function make(initial) {
      return {
        x: Math.random() * W, y: initial ? Math.random() * H : H + 10,
        r: .6 + Math.random() * 1.8, vy: .12 + Math.random() * .28, sway: 8 + Math.random() * 22,
        ph: Math.random() * 6.28, fs: .004 + Math.random() * .008, tw: Math.random() * 6.28, vt: .02 + Math.random() * .04,
        c: colors[(Math.random() * colors.length) | 0], a: .35 + Math.random() * .45
      };
    }
    function resize() {
      dpr = Math.min(w.devicePixelRatio || 1, 2);
      W = w.innerWidth; H = w.innerHeight;
      cv.width = W * dpr; cv.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = count();
      while (dots.length < n) dots.push(make(true));
      dots.length = n;
    }
    function frame(ts) {
      raf = requestAnimationFrame(frame);
      var dt = Math.min(2.5, (ts - (t0 || ts)) / 16.67 || 1); t0 = ts;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < dots.length; i++) {
        var p = dots[i];
        p.y -= p.vy * dt; p.ph += p.fs * dt; p.tw += p.vt * dt;
        if (p.y < -10) { dots[i] = make(false); continue; }
        var x = p.x + Math.sin(p.ph) * p.sway, al = p.a * (.45 + .55 * Math.abs(Math.sin(p.tw)));
        var g = ctx.createRadialGradient(x, p.y, 0, x, p.y, p.r * 4);
        g.addColorStop(0, 'rgba(' + p.c + ',' + al + ')');
        g.addColorStop(1, 'rgba(' + p.c + ',0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(x, p.y, p.r * 4, 0, 6.283); ctx.fill();
      }
      if (!shoot && ts > nextShoot) {
        shoot = { x: W * (.15 + Math.random() * .6), y: H * (.05 + Math.random() * .25), vx: 7 + Math.random() * 4, vy: 2.2 + Math.random() * 1.5, life: 0 };
      }
      if (shoot) {
        shoot.life += dt;
        var k = shoot.life / 40;
        var sx = shoot.x + shoot.vx * shoot.life, sy = shoot.y + shoot.vy * shoot.life;
        var tail = ctx.createLinearGradient(sx, sy, sx - shoot.vx * 12, sy - shoot.vy * 12);
        var a2 = Math.max(0, 1 - k) * .9;
        tail.addColorStop(0, 'rgba(255,243,207,' + a2 + ')');
        tail.addColorStop(1, 'rgba(234,210,146,0)');
        ctx.strokeStyle = tail; ctx.lineWidth = 1.6; ctx.lineCap = 'round';
        ctx.beginPath(); ctx.moveTo(sx, sy); ctx.lineTo(sx - shoot.vx * 12, sy - shoot.vy * 12); ctx.stroke();
        if (k >= 1) { shoot = null; nextShoot = ts + 9000 + Math.random() * 9000; }
      }
    }
    function start() { if (running) return; running = true; t0 = 0; nextShoot = performance.now() + 4000; raf = requestAnimationFrame(frame); }
    function stop() { running = false; cancelAnimationFrame(raf); ctx.clearRect(0, 0, W, H); }
    w.addEventListener('resize', resize, { passive: true });
    d.addEventListener('visibilitychange', function () { d.hidden ? stop() : start(); });
    resize(); start();
  }

  function boot() { initPangv(); initReveal(); initParallax(); initPointer(); initStardust(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();